import { useAuthStore } from "@/stores/auth";
import type { AdminAction } from "./types";
import { usePermissions } from "./usePermissions";

interface Props {
  /** Action key — vd "course.delete" */
  perm: AdminAction;
  /** Render khi user có quyền */
  children: React.ReactNode;
  /** Render khi KHÔNG có quyền (vd disabled button). Default null = ẩn hoàn toàn. */
  fallback?: React.ReactNode;
}

/**
 * PermissionGate — L3 RBAC defense-in-depth (UI hide).
 *
 * Usage:
 *   <PermissionGate perm="course.delete">
 *     <Button danger>Xoá khoá</Button>
 *   </PermissionGate>
 *
 *   // Hoặc disable thay vì ẩn:
 *   <PermissionGate perm="order.refund" fallback={<Button disabled>Hoàn tiền</Button>}>
 *     <Button>Hoàn tiền</Button>
 *   </PermissionGate>
 *
 * KHÔNG thay thế BE permission — BE vẫn enforce. UI gate chỉ để UX rõ ràng
 * (không show button user click vào sẽ 403).
 */
export function PermissionGate({ perm, children, fallback = null }: Props) {
  const user = useAuthStore((s) => s.user);
  const { hasAction } = usePermissions(user);

  if (!hasAction(perm)) {
    return <>{fallback}</>;
  }
  return <>{children}</>;
}
